<template>
  <div class="cTopFrom d-flex">
    <div class="select">
		<select v-model="searchType">
            <option value="product">{{ $t('search.product') }}</option>
            <option value="version">{{ $t('search.package') }}</option>
            <option value="document">{{ $t('search.document') }}</option>
            <option value="train">{{ $t('search.train') }}</option>
            <option value="faq">{{ $t('search.faq') }}</option>
            <option value="activity">{{ $t('search.activity') }}</option>
          </select>
    </div>
    <div class="from pr">
      <input
        type="text"
        v-model="searchKey"
        @keyup.enter="goSearch"
        class="t"
        :placeholder="$t('search.keyPlaceholder')"
      />
      <button class="s pointer" @click="goSearch"></button>
    </div>
  </div>
</template>

<script>
export default {
	props:{
		search_type:String,
		search_key:String,
    isRederect:{
      type:Boolean,
      default:true
    }
	},
  data() {
    return {
		searchType:this.search_type||'product',
		searchKey:this.search_key
    };
  },
  methods: {
    goSearch: function () {
		if(this.$route.path=='/search'||!this.isRederect){
			this.$emit('search',{
				type:this.searchType,
				key:this.searchKey
			})
		}else{
			this.$router.push({
				path:'/search',
				query:{
					type:this.searchType,
					kw:this.searchKey
				}
			})
		}
    },
  },
  watch:{
	search_type:function(){
		this.searchType=this.search_type
	}
  }
};
</script>

<style lang="less" scoped>
.cTopFrom {
  margin: 0 auto;
}
@media (max-width: 1200px) {
  display: block;
  .cTopFrom {
    margin: 0.3rem auto 0;
  }
}
</style>
